import { render, staticRenderFns } from "./AssetPurchase.vue?vue&type=template&id=10862249&"
import script from "./AssetPurchase.vue?vue&type=script&lang=js&"
export * from "./AssetPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports